// ページ内アンカーリンクのスクロールエフェクト
// ヘッダーが固定の場合はheaderHightにヘッダーの高さを設定(PC/SP要設定)
jQuery(function ($) {
  // var headerHeight = 0; // ヘッダー追従でない場合
  var headerHeight = $("header").innerHeight(); // ヘッダー追従の場合
  $('a[href^="#"]').click(function () {
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "html" : href);
    if (target.length > 0) {
      var position = target.offset().top - headerHeight;
      $("html, body").animate({ scrollTop: position }, 550, "swing");
      return false;
    }
  });
});

// ヘッダーの固定エフェクト
jQuery(function ($) {
  var $header = $("header");
  $(window).scroll(function () {
    if ($(window).scrollTop() > 50) {
      $header.addClass("fixed");
    } else {
      $header.removeClass("fixed");
    }
  });
});

// アコーディオンの起動
jQuery(function ($) {
  if ($("dl.accordion dt").length > 0) {
    $("dl.accordion dt").click(function () {
      $(this).next("dd").slideToggle();
      $(this).toggleClass("open");
    });
  }
});

jQuery(function ($) {
  $(".js-md-btn").each(function () {
    $(this).on("click", function (e) {
      e.preventDefault();
      var target = $(this).data("target");
      var modal = document.getElementById(target);
      $(modal).find(".js-md-overlay").fadeIn();
      $("body").addClass("noscroll");
    });
  });
  $(".js-md-close").on("click", function () {
    $(".js-md-overlay").fadeOut();
    $("body").removeClass("noscroll");
  });
});

// ドロワーメニュー // Drawer menu
jQuery(function ($) {
  if ($("#toggle").length > 0) {
    $("#toggle").click(function () {
      $(this).toggleClass("toggle_active");
      // $("#drawer_layer").fadeToggle();
      $("body").toggleClass("drawer_open");
      $("nav").fadeToggle();
      $("nav").addClass("is_open");

      // if ($(this).hasClass("toggle_active")) {
      //   $("nav").addClass("is_open");
      //   $("nav").removeClass("is_close");
      // } else {
      //   $("nav").removeClass("is_open");
      //   $("nav").addClass("is_close");
      // }
    });

    // $("#drawer_layer").click(function () {
    //   $(this).fadeOut();
    //   $("#toggle").removeClass("toggle_active");
    //   $("body").removeClass("drawer_open");
    //   $("nav").removeClass("is_open");
    //   $("nav").addClass("is_close");
    // });

    // エリア内リンク用 // For links within an area
    $("nav a").on("click", function () {
      // if (window.innerWidth <= 768) {
      if ($("#toggle:visible").length > 0) {
        $("#toggle").click();
      }
    });
  }
});
